import { createSlice } from '@reduxjs/toolkit';

export const FJSliceImageStroke = createSlice({
    name: 'sliceImageStroke',
    initialState: {
        strokeInfo: {
            type: 'none',
        },
    },
    reducers: {
        setSliceImageStrokeInfo: (state, action) => {
            state.strokeInfo = action.payload;
        },
    },
});

export const { setSliceImageStrokeInfo } = FJSliceImageStroke.actions;

export default FJSliceImageStroke.reducer;
